module.exports = __webpack_public_path__ + "d85e42414d4d8ebf4a8bd9ecb1f9f8ea.png";